module.exports = __webpack_public_path__ + "src/app/_content/imgs/endOfTerm/keep_1.jpg?27019f0bdabe69d04ae3eab305b25125";